import React, {FC} from 'react';

import BaseProgressBar from '/component/base/ProgressBar';
import {Rank} from '/constant/TestIDs';

import {styles} from './ProgressBar.style';

interface ProgressBarProps {
  percent: number;
}

export const ProgressBar: FC<ProgressBarProps> = ({
  percent = 0,
}: ProgressBarProps) => {
  return (
    <BaseProgressBar
      testID={Rank.rankProgressBar}
      progress={percent}
      style={{base: styles.progressBar, fill: styles.progressBarFill}}
    />
  );
};

export default ProgressBar;
